/// <reference types="chrome"/>

import { ChromeExtensionApiStrategy } from './chrome.extension-api.strategy';

import { DeviceDetails, LocalOverrides, NetworkDetails } from '../extension-api-interface/extension-api.interfaces';

export class ChromeLocalExtensionApiStrategy extends ChromeExtensionApiStrategy {
  constructor(private localOverrides: LocalOverrides) {
    super();
  }

  public override clearStorage = (): Promise<void> =>
    new Promise((resolve) => {
      console.log('FAKING LOCAL: Clearing storage');
      setTimeout(() => {
        resolve();
      }, 1500);
    });

  public override getDevice = async (): Promise<DeviceDetails> =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!this.localOverrides.device?.id || !this.localOverrides.device?.serialNumber) {
          reject(new Error('Device Not Managed'));
          return;
        }
        resolve({
          id: this.localOverrides.device?.id ?? 'local-device-id',
          serialNumber: this.localOverrides.device?.serialNumber ?? 'local-serial-number',
          assetId: this.localOverrides.device?.assetId ?? 'local-asset-id',
        });
      }, 1000);
    });

  public override getNetworkDetails = async (): Promise<NetworkDetails> =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        if (
          !this.localOverrides.network?.ipv4 ||
          !this.localOverrides.network?.ipv6 ||
          !this.localOverrides.network?.macAddress
        ) {
          reject(new Error('Device Not Managed'));
          return;
        }

        resolve({
          ipv4: this.localOverrides.network?.ipv4 ?? 'local-ipv4',
          ipv6: this.localOverrides.network?.ipv6 ?? 'local-ipv6',
          macAddress: this.localOverrides.network?.macAddress ?? 'local-mac-address',
        });
      }, 1000);
    });
}
